(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-competition-result-socket.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-competition-result-socket.js');
"use strict";


const useSocket = svs.components.lbUtils.socket.useSocket;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const patchPersonalResultsAction = svs.components.marketplaceCompetition.services.actions.personalResultActions.patchPersonalResultsAction;
const useCompetitionResultSocket = competitionId => {
  const dispatch = useDispatch();
  const subscriptionUrl = "/player/2/competitions/".concat(competitionId, "/result");
  useSocket(subscriptionUrl, msg => {
    if (!msg) {
      return;
    }
    let parsed;
    try {
      parsed = typeof msg === 'string' ? JSON.parse(msg) : msg;
    } catch (e) {
      return;
    }
    if (parsed) {
      dispatch(patchPersonalResultsAction({
        competitionId,
        data: parsed
      }));
    }
  }, {
    sendInitialUpdate: false,
    skip: svs.isServer || !competitionId
  });
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.useCompetitionResultSocket', useCompetitionResultSocket);

 })(window);